import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { QRcodeSvg } from './QRCodeSvg'

export const EaQRcodeIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={QRcodeSvg} {...props} />
)
